import React from 'react';
import Layout from "../components/Layout";
import Gallery from '../components/Gallery';

const GalleryPage = () => {

    return (
        <Layout>
            <Gallery />
        </Layout>
    );
};

export default GalleryPage;
